var Dlrt;
(function (Dlrt) {
    function initSwitches() {
        $('.js-switch').each((i, e) => $(e).makeSwitch());
    }
    Dlrt.initSwitches = initSwitches;
})(Dlrt || (Dlrt = {}));
$.fn.makeSwitch = function () {
    const element = this[0];
    const result = new Switchery(element, {
        size: 'small',
        color: '#00F',
        //jackColor: '#edf1f4',
        //jackSecondaryColor: '#edf1f4'
    });
    // attach the switch to its source element so it can be manipulated later without storing it separately
    element.switchery = result;
    return result;
};

//# sourceMappingURL=DelphiSwitch.js.map
